import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GetPageEditorsDTO} from 'typescript/dto/pageEditorsDto';
import ApiData from 'typescript/interfaces/ApiData';
import {IPubPageEditor} from 'typescript/models/PubPageEditor';
import User from 'typescript/models/User';

interface IState {
  pageEditors: User[];
  pageEditorsMeta: ApiData['meta'] | null;
  filters: GetPageEditorsDTO;
  usersList: IPubPageEditor[];
}

export const pageEditorsPerPage = 15;

const initialState: IState = {
  pageEditors: [],
  pageEditorsMeta: null,
  filters: {page: 1, perPage: pageEditorsPerPage, name: '', column: 'nickname', direction: 'asc'},
  usersList: [],
};

export const pageEditorSliceNamespace = 'pageEditors';

const pageEditorSlice = createSlice({
  name: pageEditorSliceNamespace,
  initialState,
  reducers: {
    setPageEditorsAC: (state, action: PayloadAction<IState['pageEditors']>) => {
      state.pageEditors = action.payload;
    },
    setPageEditorsMeta: (state, action: PayloadAction<IState['pageEditorsMeta']>) => {
      state.pageEditorsMeta = action.payload;
    },
    setUpdatedEditorAC: (state, action: PayloadAction<User>) => {
      state.pageEditors = state.pageEditors.map((editor: User) =>
        editor.id === action.payload.id ? action.payload : editor,
      );
    },
    setPageEditorFiltersAC: (state, action: PayloadAction<IState['filters']>) => {
      state.filters = action.payload;
    },
    setListOfUsersAC: (state, action: PayloadAction<IState['usersList']>) => {
      state.usersList = action.payload;
    },
  },
});

export default pageEditorSlice;

export const {setListOfUsersAC, setPageEditorFiltersAC, setPageEditorsAC, setPageEditorsMeta, setUpdatedEditorAC} =
  pageEditorSlice.actions;
